import React from "react";
import { motion } from "framer-motion";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";

function About() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { staggerChildren: 0.2 } 
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 }
  };

  return (
    <section className="relative min-h-screen py-32 bg-dark overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center mb-24"
        >
          {/* About Text Content */}
          <motion.div 
            variants={itemVariants}
            className="lg:col-span-7 space-y-8"
          >
            <h1 className="text-4xl md:text-5xl font-bold font-manrope">
              Know Who <span className="text-primary italic">I AM</span>
            </h1>
            <div className="glass p-8 rounded-3xl border-white/5 shadow-2xl">
              <Aboutcard />
            </div>
          </motion.div>

          {/* About Image */}
          <motion.div 
            variants={itemVariants}
            className="lg:col-span-5 relative group"
          >
            <div className="absolute -inset-4 bg-primary/10 blur-3xl rounded-full scale-75 group-hover:scale-100 transition-transform duration-700"></div>
            <img 
              src={laptopImg} 
              alt="about" 
              className="relative w-full max-w-[450px] mx-auto filter drop-shadow-[0_0_30px_rgba(205,95,248,0.2)]" 
            />
          </motion.div>
        </motion.div>

        {/* Skillset Section */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="space-y-12"
        >
          <div className="text-center">
            <h2 className="text-3xl md:text-5xl font-bold font-manrope">
              Professional <span className="text-primary">Skillset</span>
            </h2>
            <div className="w-24 h-1 bg-primary/30 mx-auto mt-4 rounded-full"></div>
          </div>
          
          <Techstack />
        </motion.div>
      </div>
    </section>
  );
}

export default About;
